import React from 'react'

import { GetCustomerRewardsOrderDocument } from '../../../../graphql/camel'
import useCamelQuery from '../../../../hooks/useCamelQuery'
import { RewardsSourceConfig } from '../../../../lib/rewards/sources'
import ShipmentsContainer from './ShipmentsContainer'

export interface RewardsShipmentsContainerProps {
  orderId: string
  rewardsSource: RewardsSourceConfig
}

const RewardsShipmentsContainer: React.FC<RewardsShipmentsContainerProps> = ({
  orderId,
  rewardsSource,
}) => {
  const { slug } = rewardsSource
  const { data } = useCamelQuery(GetCustomerRewardsOrderDocument, {
    variables: {
      orderId,
    },
  })

  const order = data && data.getCustomerRewardsOrder

  return <ShipmentsContainer order={order} urlFragment={`rewards/orders/${slug}`} />
}

export default RewardsShipmentsContainer
